// Ok
export const STATUS_SUCCESS = 200

// Errores
export const STATUS_409 = 409
export const ERROR_500 = 500;

export const ERROR_MESSAGE = 'Error interno';